export const APPLICATION_END_STATUS = {
  COMPLETED: 'completed',
  IDENTITY_FAILED: 'identity_failed',
  CREDIT_CHECK_DECLINED: 'credit_check_declined',
  IN_REVIEW: 'in_review',
  UNKNOWN: 'unknown'
} as const;
